// Auto-generated route index - replaces require.context
import { Routes } from '@angular/router';
import { authRoutes } from './auth.route';
import { dashboardRoutes } from './dashboard.route';
import { diffJobsRoutes } from './diff-jobs.route';
import { localizationConfigurationRoutes } from './localization-configuration.route';
import { seasonalPrizesRoutes } from './seasonal-prizes.route';
import { sponsorsRoutes } from './sponsors.route';
import { lazyFeatureRoutes } from './lazy-features';

// Still eager: auth is part of the shell and dashboard lazy-loads itself. The other four have their
// components also routed from app-routing.module.ts, so splitting them wouldn't shrink main yet.
const allRouteModules = [
  authRoutes,
  dashboardRoutes,
  diffJobsRoutes,
  localizationConfigurationRoutes,
  seasonalPrizesRoutes,
  sponsorsRoutes,
];

const allRouteConfigs = [
  // Entity features load on demand; see lazy-features.ts.
  ...lazyFeatureRoutes,
  ...allRouteModules.map(routeModule => routeModule?.routes() || []).flat(),
];

export const routes: Routes = allRouteConfigs;
